export const STEP_INITIAL = 'initial';
export const STEP_CONFIRM = 'confirm';
export const STEP_DONE = 'done';

export const SEARCH_PAYMENT_FORM = 'requestForSearchPayment';

export const helpTxtUin =
  'УИН — это уникальный идентификатор начисления, он состоит из 20 цифр. В квитанциях это поле обычно называется Индекс документа, а в платежных поручениях — Код';
export const helpTxtSum = 'Укажите сумму с точностью до копеек';
export const helpTxtDate = 'Укажите как минимум одну дату';
export const validateMessageUin = 'Поле должно содержать 20 символов';
export const validateMessageSum = 'Введите сумму с указанием копеек';

export const radioUin = '1';
export const radioSum = '2';

export const radioValues = [
  {
    label: 'УИН',
    value: radioUin,
  },
  {
    label: 'Сумма и дата',
    value: radioSum,
  },
];
